import defaultContent from '../../../content/sessionDetail';
import { useTranslation } from 'react-i18next';
import Title from '../../common/Title/Title';
import Section from '../../common/Section/Section';
import { Input } from '../../common/Input/Input';
import Button from '../../common/Button/Button';
import SelectComponent from '../../common/Select/Select';
import { mockApplication, mockPlatform, mockStatus } from '../../../mocks/data';
import { Textarea } from '../../common/Textarea/Textarea';

export const SessionDetail = () => {
  const { t } = useTranslation(['sessionDetail']);
  const title = t('sessionDetail', defaultContent['sessionDetail']).toString();

  const sessionDetail = (
    <div className="container">
      <Title text={title} />
      <div className="h-3"></div>
      <div className="row">
        <div className="column-one">
          <Section text={'Session Login'} />
        </div>
      </div>
      <div className="h-2"></div>
      <div className="row">
        <div className="column-three">
          <Input label={'Session Login ID'} readOnly={false} />
        </div>
        <div className="column-three">
          <SelectComponent isMulti={false} label={'Application'} options={mockApplication} />
        </div>
        <div className="column-three">
          <SelectComponent isMulti={false} label={'Platform'} options={mockPlatform} />
        </div>
      </div>
      <div className="h-1"></div>
      <div className="row">
        <div className="column-one">
          <Textarea label={'Session Login Access Token'} readOnly={false} />
        </div>{' '}
      </div>
      <div className="h-1"></div>
      <div className="row">
        <div className="column-one">
          <Textarea label={'Session Identity Provider Access Token'} readOnly={false} />
        </div>
      </div>
      <div className="h-3"></div>
      <div className="row">
        <div className="column-one">
          <Section text={'Session User'} />
        </div>
      </div>
      <div className="h-2"></div>
      <div className="row">
        <div className="column-two">
          <Input label={'Session User ID'} readOnly={false} />
        </div>

        <div className="column-two">
          <SelectComponent isMulti={false} label={'Status'} options={mockStatus} />
        </div>
      </div>
      <div className="h-1"></div>
      <div className="row">
        <div className="column-one">
          <Textarea label={'Session User Authentication'} readOnly={false} />
        </div>
      </div>
      <div className="h-1"></div>
      <div className="row">
        <div className="column-one">
          <Textarea label={'Session User Access Token'} readOnly={false} />
        </div>
      </div>
      <div className="h-2"></div>
      <div className="row">
        <div className="column-one">
          <Button
            text="Save Changes"
            color="primary-purple"
            disabled={false}
            action={function (): void {
              throw new Error('Function not implemented.');
            }}
          />
          <span className="spacing-one"></span>
          <Button
            text="Cancel"
            color="primary-white"
            disabled={false}
            action={function (): void {
              throw new Error('Function not implemented.');
            }}
          />
        </div>
      </div>
      <div className="h-3"></div>
    </div>
  );

  return <>{sessionDetail}</>;
};

export default SessionDetail;
